import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ExecutionMobileLayout from '../execution/ExecutionMobileLayout';
import ExecutionTasksTab from '../execution/ExecutionTasksTab';
import ExecutionHistoryTab from '../execution/ExecutionHistoryTab';
import ExecutionLearnTab from '../execution/ExecutionLearnTab';
import ExecutionProfileTab from '../execution/ExecutionProfileTab';
import ExecutionTaskExecutionView from '../execution/ExecutionTaskExecutionView';
import UpdateNotification from '../shared/UpdateNotification';
import './ExecutionDashboard.css';

/**
 * Execution Dashboard (PRD: execution_account_prd).
 * Mobile-first, bottom nav: Tasks, History, Learn, Profile.
 * Task execution and quiz run full-screen (nav hidden).
 */
const ExecutionDashboard = ({
  onLogout,
  userRole,
  userData,
  dashboardConfig,
}) => {
  const { t } = useTranslation('execution');
  const [activeTab, setActiveTab] = useState('tasks');
  const [userName, setUserName] = useState('');
  const [executingTask, setExecutingTask] = useState(null);
  const [hideNav, setHideNav] = useState(false);

  useEffect(() => {
    if (userData) {
      setUserName(
        userData.full_name ||
          `${userData.first_name || ''} ${userData.last_name || ''}`.trim() ||
          userData.email ||
          '',
      );
    }
  }, [userData]);

  const handleBackFromExecution = () => {
    setExecutingTask(null);
    setHideNav(false);
    setActiveTab('tasks');
  };

  const handleStartOrContinueTask = (task) => {
    setExecutingTask(task);
    setHideNav(true);
  };

  const renderContent = () => {
    if (executingTask) {
      return (
        <ExecutionTaskExecutionView
          task={executingTask}
          userId={userData?.uid}
          onBack={handleBackFromExecution}
        />
      );
    }

    switch (activeTab) {
      case 'tasks':
        return (
          <ExecutionTasksTab
            userId={userData?.uid}
            onStartOrContinueTask={handleStartOrContinueTask}
          />
        );
      case 'history':
        return <ExecutionHistoryTab userId={userData?.uid} />;
      case 'learn':
        return <ExecutionLearnTab userId={userData?.uid} />;
      case 'profile':
        return (
          <ExecutionProfileTab
            userData={userData}
            userName={userName}
            onLogout={onLogout}
          />
        );
      default:
        return (
          <ExecutionTasksTab
            userId={userData?.uid}
            onStartOrContinueTask={handleStartOrContinueTask}
          />
        );
    }
  };

  return (
    <>
      <ExecutionMobileLayout
        activeTab={activeTab}
        onTabChange={setActiveTab}
        hideNav={hideNav}
        userName={userName}
      >
        {renderContent()}
      </ExecutionMobileLayout>
      <UpdateNotification />
    </>
  );
};

export default ExecutionDashboard;
